import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from "@/components/primitives";
import { Activity } from "lucide-react";
import type { Signal } from "../types";

interface SignalsCardProps {
	signals: Signal[];
}

export function SignalsCard({ signals }: SignalsCardProps) {
	if (signals.length === 0) {
		return null;
	}

	return (
		<Card className="border-2 shadow-xl bg-white/90 dark:bg-slate-800/90 backdrop-blur-sm print-borderless">
			<CardHeader className="pb-4 border-b bg-gradient-to-r from-blue-50/50 to-indigo-50/50 dark:from-blue-950/20 dark:to-indigo-950/20">
				<div className="flex items-center gap-3">
					<div className="p-2 rounded-lg bg-gradient-to-br from-orange-500 to-amber-600 print-signals-icon">
						<Activity className="h-5 w-5 text-white" />
					</div>
					<div>
						<CardTitle className="text-xl sm:text-2xl font-semibold">
							Warning Signals ({signals.length})
						</CardTitle>
					</div>
				</div>
			</CardHeader>
			<CardContent className="pt-6">
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
					{signals.map((signal) => (
						<div
							key={signal.id}
							className="border-2 rounded-lg p-4 bg-orange-50/50 dark:bg-orange-900/10 border-orange-200 dark:border-orange-800 shadow-md"
						>
							<h4 className="font-semibold text-foreground mb-2">
								{signal.title}
							</h4>
							<p className="text-sm text-muted-foreground leading-relaxed">
								{signal.description}
							</p>
						</div>
					))}
				</div>
			</CardContent>
		</Card>
	);
}
